import React, { useState, useEffect } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const TextArea = (props) => {
  const [textValue, setTextValue] = useState(props.value);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (props && props.hasOwnProperty('value')) {
      setTextValue(props.value);
    }
  }, [props, textValue])

  useEffect(() => {
    if (props && props.error) {
      if (Object.keys(props.error).length) {
        Object.entries(props.error).forEach(([key, value]) => {
          if (key === props.name) {
            setErrorMsg(value.toString());
          }
        })
      } else if (errorMsg.length) {
        setErrorMsg('');
      }
    }
  }, [props, errorMsg])
  
  return (
    <div name={ props.name } className={ `coral-Form-fieldwrapper ${(errorMsg && errorMsg.length) ? 'error' : ''}` } style={{display: (props.hidden) ? 'none' : 'block'}}>
      <label className="coral-Form-fieldlabel">
        { props.label }
        <small className="required-label">{ props['data-required'] ? `${ props['data-required-label'] }`: '' }</small>
      </label>
      <CKEditor
        editor={ ClassicEditor }
        data={ textValue }
        config={{
          toolbar: [ "bold", "italic", "|", "link", "|", "bulletedList", "numberedList", "|", "insertTable", "|", "undo", "redo" ],
          disableNativeSpellChecker: false
        }}
        onChange={ (event, editor) => {
          const data = editor.getData();
          props.onChange(props.name, data);
        }}
      />
      <span className={ `${(errorMsg && errorMsg.length) ? 'help-block field-error' : ''}` }>{ errorMsg }</span>
    </div>
  )
}

export default TextArea;